import Utility from "./../../utilities/Utility";
import CollectionManager from "./../../utilities/CollectionManager";
import BranchMergeEventFactory from "./BranchMergeEventFactory";
import DesignerSetting from "../../DesignerSetting";
import { DesignBranchingEventType } from "../../types";
import {
	addBranchingEvent,
	incrementVersion
} from "../functions";
import { defaultServiceContext } from "../../contexts";
import { createDesignChangeMap } from './functions';

/**
 * JSDoc imports.
 * @import { Design } from "../../types";
 */

const moment = require("moment");
const { avsService } = defaultServiceContext;

export default class BranchManager {
	/**
	 * Instantiate BranchManager Class
	 * @param {object} appManager
	 */
	constructor(appManager) {
		this.appManager = appManager;
		this.collectionManager = new CollectionManager();
		this.branchMergeEventFactory = new BranchMergeEventFactory();
	}

	/**
	 * @param {Design} mainBranch to create a branch from.
	 * @param {string} branchName for the newly created branch.
	 * @param {number} timestamp for the branch's creation.
	 */
	getInitializedBranch(mainBranch, branchName, timestamp) {
		const branchId = Utility.uuid4();
		const author = window.apm.getDesignerAuthor();
		const branch = _.cloneDeep(mainBranch);

		delete branch.branching;
		delete branch.branchingMap;
		delete branch["$loki"];

		branch._id = branchId;
		branch.branchId = branchId;
		branch.branchName = branchName;
		branch.version = "1.0.0";
		branch.repoVersion = "1.0.0";
		addBranchingEvent(branch, this.branchMergeEventFactory.getEvent(
			DesignBranchingEventType.initBranch,
			{ mainBranch, timestamp, author }
		));

		return branch;
	}

	async initFeatureBranch(mainBranch, branchName, author) {
		const timestamp = (window && window.apm && window.apm.timestamp) ? window.apm.timestamp : moment.now(); 
		const mainOriginal = _.cloneDeep(mainBranch);
		// initialize branch
		const featureBranch = this.getInitializedBranch(mainBranch, branchName, timestamp);

		const commitMessage = "Branch created: " + featureBranch["application"] + " from " + mainBranch.application + " version " + mainBranch.version;

		const savedFrom = mainBranch.version;

		const featureBranchChangeLogMap = [
			{
				author,
				version: featureBranch.version,
				changeLogMap: [
					createDesignChangeMap(featureBranch, mainOriginal),
					{}
				],
				commitMessage,
				d2commit: DesignerSetting.s.commit,
				env: DesignerSetting.s.env,
				timeStamp: timestamp,
				savedFrom
			}
		];
		
		// initialize/update main branch
		const {
			branchId,
			version: originalVersion
		} = mainBranch;

		mainBranch.branchingMap = mainBranch.branchingMap || {};
		addBranchingEvent(mainBranch, this.branchMergeEventFactory.getEvent(
			DesignBranchingEventType.initBranchingMap,
			{ mainBranch: mainBranch, featureBranch, timestamp, author }
		));

		const newVersion = incrementVersion(mainBranch.version);
		mainBranch.version = newVersion;
		mainBranch.repoVersion = newVersion;

		const mainBranchChangeLogEntry = this.getChangeLogEntry({
			author,
			version: mainBranch.version,
			changeLogMap: [
				createDesignChangeMap(mainBranch, mainOriginal),
				{}
			],
			reason: "Modified",
			commitMessage,
			d2commit: DesignerSetting.s.commit,
            env: DesignerSetting.s.env,
			savedFrom
		});

		const mainBranchChangeLogMap = await avsService.getChangeLogs(branchId, originalVersion);
		mainBranchChangeLogMap.unshift(mainBranchChangeLogEntry);

		return { mainBranch, mainBranchChangeLogMap, featureBranch, featureBranchChangeLogMap };
	}

	getChangeLogEntry(obj) {
		const { author, latestVersion, version, saveAsNewVersion, changeLogMap, initial, commitMessage, savedFrom } = obj;

		return this.appManager.getChangeLogEntry({ author, latestVersion, version, saveAsNewVersion, changeLogMap, initial, commitMessage, savedFrom });
	}
}
